<template>
	<div class="loading">
		<img src="img/loading.gif"/>
	</div>
</template>